class ZoomAccessibility {
    constructor() {
        this.observer = new MutationObserver(() => this.processZoom());
    }

    init() {
        window.addEventListener('load', () => {
            this.addDefaultAlt();
            this.startObserver();
        });
    }

    startObserver() {
        const container = document.querySelector('.primary-images');
        if(!container) {
            return;
        }

        this.observer.observe(container, {
            childList: true,
            subtree: true
        });
    }

    addDefaultAlt() {
        const sourceImage = document.querySelector('img.secondary-image');
        const zoomImage = document.querySelector('.zoomImg');

        if(sourceImage && zoomImage) {
            zoomImage.alt = sourceImage.alt;
        }
    }

    processZoom() {
        const zoomImages = document.querySelectorAll('.zoomImg');

        zoomImages.forEach(image => {
            const container = image.closest('.image-container');
            if(!container) {
                return;
            }

            const link = container.querySelector('a');
            if(!link) {
                return;
            }

            const altText = link.title;
            image.alt = altText;
        });
    }

    disconnect() {
        this.observer.disconnect();
    }
}
